import {Resource} from "./Resource";

export default class CssResource extends Resource {
    load(): Promise<void> {
        return this.addStylesheetToPage();
    }

    protected addStylesheetToPage() {
        return new Promise<void>((resolve, reject) => {
            let document = window.document;
            let refs = document.getElementsByTagName("head")[0].childNodes;
            let ref = refs[ refs.length - 1];

            let stylesheet = document.createElement("link");
            stylesheet.type = "text/css";
            stylesheet.rel = "stylesheet";
            stylesheet.media = "all";
            stylesheet.href = this.source;

            let eventsListeners = {
                clear: () => {
                    stylesheet.removeEventListener("load", eventsListeners.load);
                    stylesheet.removeEventListener("error", eventsListeners.error);
                },
                load: () => { eventsListeners.clear(); resolve(); },
                error: () => { eventsListeners.clear(); reject(); }
            };

            stylesheet.addEventListener("load", eventsListeners.load);
            stylesheet.addEventListener("error", eventsListeners.error);

            ref.parentNode.insertBefore(stylesheet, ref.nextSibling);
        });
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/resources/Css.ts
 **/